<template>
<div>
    <mu-appbar style="width: 100%;" color="#2196f3">
        <mu-button icon slot="left" @click="goback">
            <mu-icon value="arrow_back"></mu-icon>
        </mu-button>
        <div slot="right" style="display: flex;align-items: center;">
            <div></div>
            <mu-button icon >
                <mu-icon value="keyboard1_arrow_down"></mu-icon>
            </mu-button>
        </div>

        实名认证
    </mu-appbar>
<br>
    <van-form @submit="onSubmit">
  <van-field
    v-model="realname"
    name="姓名"
    label="姓名"
    placeholder="姓名"
    :rules="[{ required: true, message: '请填写您的真实姓名' }]"
  />
  <van-field
    v-model="idnumber"
   
    name='身份证号码'
    label="身份证号码"
    placeholder="身份证"
    :rules="[{ required: true, message: '请填写身份证号码' }]"
  />
  <van-field name="uploader" label="身份证正面">
  <template #input>
    <van-uploader v-model="uploader1" multiple :max-count="1" :after-read='uploadfile1'/>
  </template>
</van-field>

<van-field name="uploader" label="身份证反面">
  <template #input>
    <van-uploader v-model="uploader2"  multiple :max-count="1" :after-read='uploadfile2'/>
  </template>
</van-field>
  <div style="margin: 16px;">
    <van-button round block type="info" native-type="submit">提交</van-button>
  </div>
</van-form>
   

</div>
</template>

<script>
import Api from '@/api'
import moment from 'moment'
import axios from 'axios'
export default {

    created() {
        this.refresh();
    },
    actived() {
        this.refresh();
    },
    
    data() {
        return {
           
           realname:"",
           idnumber:"",
           uploader1:[],
           uploader2:[],
           idphone1:"",
           idphone2:'',

           
        }
    },

filters: {
        number2str(n) {
            return n.toFixed(1)
        },
        code2label(code){
       
         if(!code){
             return ""
         }
         return code;
         
       }
    },

    methods: {
        uploadfile1(file) {


          window.uploadImage(file.file,(url)=>{
              this.idphoto1=url;
          })
        },
         uploadfile2(file) {
          window.uploadImage(file.file,(url)=>{
              this.idphoto2=url;
          })
        },
      
        goback() {
            this.$router.go(-1);
        },
        onSubmit() {
            console.log(this.idphoto1)
             console.log(this.idphoto2)
             console.log(this.idnumber)
             console.log(this.realname)
             Api.auth({"realname":this.realname,"idnumber":this.idnumber,"img1_url":this.idphoto1,"img2_url":this.idphoto2}).then((res)=>{
                if(res.data['success']) {
                     this.$toast("提交成功");
                }
             })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/Auth.vue